//请自行添加语言资源
const customerSku = {

  msg:{

  }
};
export default customerSku



// WEBPACK FOOTER //
// ./src/page/md/customerSku/lang/customerSku.zh.js